'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".PreferencesStatus-module_preferencesStatusWrapper__E2R9B{align-items:center;display:flex;gap:4px;justify-content:center;margin-bottom:2rem;text-align:center}.PreferencesStatus-module_preferencesStatusDescription__YySHD{align-items:center;display:flex;gap:8px}.PreferencesStatus-module_preferencesStatusLink__OXVzy{font-weight:700;-webkit-text-decoration:none;text-decoration:none}";
var styles = {"preferencesStatusWrapper":"PreferencesStatus-module_preferencesStatusWrapper__E2R9B","preferencesStatusDescription":"PreferencesStatus-module_preferencesStatusDescription__YySHD","preferencesStatusLink":"PreferencesStatus-module_preferencesStatusLink__OXVzy"};
styleInject["default"](css_248z, 'e6008a07-a3b2-4e6a-9ed1-a0f6dfd1b0e2');

exports["default"] = styles;
